/* *
 * Copyright (C) 2023 S&P Global.
 * All Rights Reserved
 * Notice: The information, data, processing technology, software (including source code),
 * technical and intellectual concepts and processes and all other materials provided
 * (collectively the "Property") are Copyright © 2023, S&P Global and/or its affiliates
 * (together "S&P Global") and constitute the proprietary and confidential information of
 * S&P Global. S&P Global reserves all rights in and to the Property. Any copying,
 * reproduction, distribution, transmission or disclosure of the Property, in any form, is
 * strictly prohibited without the prior written consent of S&P Global. Unless otherwise
 * agreed in writing, the Property is provided on an "as is" basis and S&P Global makes no
 * warranty, express or implied, as to its accuracy, completeness, timeliness, or to any
 * results to be obtained by recipient nor shall S&P Global in any way be liable to any
 * recipient for any inaccuracies, errors or omissions in the Property. Without limiting the
 * generality of the foregoing, S&P Global shall have no liability whatsoever to any
 * recipient of the Property, whether in contract, in tort (including negligence), under
 * warranty, under statute or otherwise, in respect of any loss or damage suffered by any
 * recipient as a result of or in connection with such Property, or any course of action
 * determined, by it or any third party, whether or not based on the Property. S&P Global,
 * the S&P Global logo, and the IHS Markit logo are registered trademarks of S&P Global,
 * and the trademarks of S&P Global used herein are protected by international laws.
 * Any other names may be trademarks of their respective owners.
 **/
const NO_ACCESS_PATH: string = '/no-access';
const NO_ACCESS_RETURN_STATE_KEY: string = 'pcs:no-access-return-state';
const NO_ACCESS_QUERY_PARAM_NAMES: readonly string[] = ['reason', 'email'];

function getNoAccessHashWithQueryParams(hash: string): string | null {
  const [path, query = ''] = hash.slice(1).split('?');
  if (path !== NO_ACCESS_PATH) return null;

  const queryParams = new URLSearchParams(query);
  const preservedQueryParams = new URLSearchParams();

  for (const name of NO_ACCESS_QUERY_PARAM_NAMES) {
    const value = queryParams.get(name);
    if (value !== null) {
      preservedQueryParams.set(name, value);
    }
  }

  const preservedQuery = preservedQueryParams.toString();
  return preservedQuery ? `#${NO_ACCESS_PATH}?${preservedQuery}` : null;
}

function isNoAccessPath(hash: string): boolean {
  return hash.slice(1).split('?')[0] === NO_ACCESS_PATH;
}

export function preserveNoAccessRouteState(): void {
  const noAccessHash = getNoAccessHashWithQueryParams(window.location.hash);
  if (!noAccessHash) return;

  try {
    window.sessionStorage.setItem(NO_ACCESS_RETURN_STATE_KEY, noAccessHash);
  } catch {
    return;
  }
}

export function restoreNoAccessRouteState(): void {
  let noAccessHash: string | null;

  try {
    noAccessHash = window.sessionStorage.getItem(NO_ACCESS_RETURN_STATE_KEY);
  } catch {
    return;
  }

  if (!noAccessHash) return;

  if (window.location.hash === noAccessHash) return;

  try {
    if (isNoAccessPath(window.location.hash)) {
      window.history.replaceState(window.history.state, '', noAccessHash);
    }
  } catch {
    return;
  }
}

export function clearNoAccessRouteState(): void {
  try {
    window.sessionStorage.removeItem(NO_ACCESS_RETURN_STATE_KEY);
  } catch {
    return;
  }
}
